// removed by extract-text-webpack-plugin
module.exports = {"root":"NotFound__root--3_OTV","content":"NotFound__content--24YvI","overlay":"NotFound__overlay--28WOp","title":"NotFound__title--WLkcn","titleBackground":"NotFound__titleBackground--2vH-b","description":"NotFound__description--3jLgt thinBigText","descriptionBackground":"NotFound__descriptionBackground--3kW2u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/screens/NotFound/NotFound.css
// module id = tDUz
// module chunks = 0